<script lang="ts" setup>
import type { TripOverview } from "@/api/trips/dto/trip.dto";
import { useRoute, useRouter } from "vue-router";
import { watch } from "vue";

const location = useRoute();
const router = useRouter();

const props = defineProps<{
  trip: TripOverview;
}>();

const emits = defineEmits(["change"]);

watch(
  () => props.trip,
  (value) => {
    if (!location.params.routeId && value) {
      router.push({ name: "trip-check-calls-route", params: { id: props.trip.id, routeId: props.trip.routes[0]?.id } });
    }
  },
  { immediate: true },
);
</script>

<template>
  <div class="my-4">
    <v-btn
      v-for="route in props.trip?.routes"
      :key="route.id"
      :to="{ name: 'trip-check-calls-route', params: { id: trip.id, routeId: route.id } }"
      active-color="primary"
      variant="flat"
    >
      Truck #{{ route.truck?.number }}
    </v-btn>
  </div>
  <router-view v-slot="{ Component }">
    <component :is="Component" :trip="trip" @update="emits('change')" />
  </router-view>
</template>

<style lang="scss" scoped></style>
